import style from "./CountrySelect.module.scss";

export function CountrySelect() {
    return (
        <div className={style.container}>
            <p className={style.label}>Гео:</p>
            <div className={style.valueBox}>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
                    <g opacity="0.5">
                        <path d="M16.8206 0H2.10258C1.54494 0 1.01014 0.221521 0.615831 0.61583C0.221521 1.01014 0 1.54494 0 2.10258L0 6.83338H18.9232V2.10258C18.9232 1.54494 18.7017 1.01014 18.3074 0.61583C17.9131 0.221521 17.3783 0 16.8206 0Z" fill="#005BBB" />
                        <path d="M18.9232 11.5642C18.9232 12.1218 18.7017 12.6566 18.3074 13.0509C17.9131 13.4452 17.3783 13.6667 16.8206 13.6667H2.10258C1.54494 13.6667 1.01014 13.4452 0.615831 13.0509C0.221521 12.6566 0 12.1218 0 11.5642V6.83337H18.9232V11.5642Z" fill="#FFD500" />
                    </g>
                </svg>
                <p className={style.value}>Україна</p>
            </div>
            <svg className="shrink-0 select-none cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                <path opacity="0.5" d="M5.46967 6.53033C5.76256 6.82322 6.23744 6.82322 6.53033 6.53033L11.3033 1.75736C11.5962 1.46447 11.5962 0.989592 11.3033 0.696699C11.0104 0.403806 10.5355 0.403806 10.2426 0.696699L6 4.93934L1.75736 0.696699C1.46447 0.403806 0.989592 0.403806 0.696699 0.696699C0.403806 0.989593 0.403806 1.46447 0.696699 1.75736L5.46967 6.53033ZM5.25 5L5.25 6L6.75 6L6.75 5L5.25 5Z" fill="#838199" />
            </svg>
        </div>
    )
}